import React from 'react';
import { Row, Col, Alert, Form } from 'react-bootstrap';

function PermisesTab() {

    const auth = JSON.parse(localStorage.getItem('auth')!)
    const value = `${auth?.location?.StreetAddress ? auth?.location?.StreetAddress : ''} ${auth?.location?.City ? auth?.location?.City : ''} ${auth?.location?.ZipCode ? auth?.location?.ZipCode : ''}`


    return (
        <div>
            <Row>
                <Col>
                    <Form>
                        <Form.Group className="mb-3" controlId="premiseAddress">
                            <Form.Label>Premise address1</Form.Label>
                            <Row>
                                <Col md="8"><Form.Control isValid value={value} disabled type="text" /></Col>
                            </Row>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="billingAddress">
                            <Form.Label>Billing address</Form.Label>
                            <Row>
                                {/* <Col md="8"><Form.Control isValid value={"#21-5 60 Chestnut Avenue , Singapore 679517"} disabled type="text" /></Col> */}
                                <Col md="8"><Form.Control isValid value={value} disabled type="text" /></Col>
                            </Row>
                        </Form.Group>
                    </Form>
                    <Alert variant='info'><i className="fa-solid fa-circle-info"></i> If you wish to change your registered address, please contact our customer service via <a href='mailto:customercare@solarshare.sg'>customercare@solarshare.sg</a></Alert>
                </Col>
            </Row>
        </div>
    );
}

export default PermisesTab;
